<template>
    <div>
        <div v-if="documentTest.hasFinished" class="border p-4 text-center">
            <div v-if="currentDocument.isPassed">
                <font-awesome-icon icon="check-circle" color="green" size="4x"/>
                <p class="font-weight-bold mt-3">Tests nokārtots.</p>
            </div>
            <div v-else>
                <font-awesome-icon icon="times-circle" color="red" size="4x" class="mt-2"/>
                <p class="font-weight-bold mt-3">Tests nav nokārtots.</p>
                <p>Nepieciešamais pareizo atbilžu skaits ir {{ currentDocument.documentForm.completionAmount }}.</p>
            </div>

            <p>
                Jūs atbildējāt pareizi uz {{ currentDocument.latestUserResult.correctAnswers }} no {{ documentTest.questionCount }} jautājumiem.
            </p>

            <router-link v-if="currentDocument.isPassed" to="/" class="ds-btn ds-btn--success">
                Atpakaļ uz sākumu
            </router-link>
            <button v-else class="ds-btn ds-btn--danger" @click="$emit('retry')">
                Atkārtot testu
            </button>
        </div>
        <ValidationObserver v-else
                            ref="documentTestForm"
                            tag="form"
                            class="border p-3"
                            @submit.prevent="submitAnswer">
            <b-progress class="ds-progress mt-2" :max="documentTest.questionCount" show-value>
                <b-progress-bar :value="documentTest.currentQuestion" variant="success"/>
            </b-progress>

            <ValidationProvider tag="div"
                                vid="currentSelectedAnswer"
                                mode="lazy"
                                :customMessages="{required: 'Lūdzu, izvēlies atbildi!'}"
                                rules="required"
                                v-slot="{errors}"
                                class="row justify-content-center my-4">
                <b-form-group class="col-auto">
                    <div class="text-center my-3"><h4>{{documentTest.currentQuestionTitle}}</h4></div>
                    <b-form-radio class="mb-1"
                                  v-model="documentTest.currentQuestionSelectedAnswer"
                                  v-for="(answer, i) in documentTest.currentQuestionAnswers"
                                  :key="`answer-${i}`"
                                  name="currentSelectedAnswer"
                                  :value="answer.key">
                        {{ answer.title }}
                    </b-form-radio>
                    <span class="text-danger d-block text-left small mt-1 mb-3">{{ errors[0] }}</span>
                </b-form-group>
            </ValidationProvider>
            <div class="row justify-content-center my-4">
                <div class="col-4">
                    <button @click="documentTest.goBack()"
                            class="ds-btn ds-btn--default mr-3"
                            :class="{'ds-btn--disabled': documentTest.isFirstQuestion}"
                            :disabled="documentTest.isFirstQuestion"
                            type="button">
                        Iepriekšējais
                    </button>
                    <button class="ds-btn ds-btn--default" type="submit">
                        {{ documentTest.isLastQuestion ? 'Pabeigt' : 'Nākamais' }}
                    </button>
                </div>
            </div>

        </ValidationObserver>
    </div>
</template>
<script>
    import {mapGetters, mapActions} from 'vuex';
    import {ValidationObserver, ValidationProvider, extend} from 'vee-validate';
    import {required} from 'vee-validate/dist/rules';

    import * as documentStoreTypes from '../../vuex/modules/document/document.store-types';
    import {DocumentTest} from '../../vuex/modules/document/models/document-test.models';

    export default {
        name: 'document-test',
        components: {
            ValidationProvider,
            ValidationObserver,
        },
        data: () => ({documentTest: null}),
        async created() {
            extend('required', required);

            this.startTest();
        },
        computed: mapGetters('document', {
            /** @type {Document|*} */
            currentDocument: documentStoreTypes.GET_CURRENT_DOCUMENT,
        }),
        methods: {
            ...mapActions('document', {
                /** @type {function|*} */
                finishTest: documentStoreTypes.ACTION_FINISH_TEST,
            }),
            async submitAnswer() {
                const isValid = await this.$refs.documentTestForm.validate();

                if (!isValid) {
                    return;
                }

                if (this.documentTest.isLastQuestion) {
                    await this.finishTest({
                        documentId: this.$route.params.documentId,
                        answeredQuestionsPath: Object.fromEntries(this.documentTest.answeredQuestionsPath.entries()),
                    });

                    return this.documentTest.markAsFinished();
                }

                this.$refs.documentTestForm.reset();
                this.documentTest.goToNextQuestion();
            },
            startTest() {
                this.documentTest = new DocumentTest(this.currentDocument.documentForm);
            },
        }
    }
</script>